export const baseConfig = {
  NODE_ENV: process.env.NODE_ENV,
  RELEASE_SHA: process.env.REACT_APP_RELEASE_SHA,
  CAPTUR_API_CORE_URL: process.env.REACT_APP_CAPTUR_API_CORE_URL,
  CAPTUR_API_TASKS_URL: process.env.REACT_APP_CAPTUR_API_TASKS_URL,
  CAPTUR_KEY_DASHBOARD: process.env.REACT_APP_CAPTUR_KEY_DASHBOARD,
  SENTRY_DSN_DASHBOARD: process.env.REACT_APP_SENTRY_DSN_DASHBOARD,
  SENTRY_ORGANISATION: process.env.REACT_APP_SENTRY_ORGANISATION,
  SENTRY_PROJECTID_DASHBOARD: process.env.REACT_APP_SENTRY_PROJECTID_DASHBOARD,
  POSTHOG_ANALYTICS_HOST: process.env.REACT_APP_POSTHOG_ANALYTICS_HOST,
  POSTHOG_ANALYTICS_TOKEN_DASHBOARD:
    process.env.REACT_APP_POSTHOG_ANALYTICS_TOKEN_DASHBOARD,
  CAPTUR_PWA_URL: process.env.REACT_APP_CAPTUR_PWA_URL,
  FF: process.env.REACT_APP_FF ? JSON.parse(process.env.REACT_APP_FF) : false,
  DATADOG_APPLICATION_ID: process.env.REACT_APP_DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  DATADOG_SITE: process.env.REACT_APP_DATADOG_SITE
};
